import { SVG_FillRect } from "./SVG_FillRect";

export function SVG_DrawBackground(x, y, width, height, bkgroundColor, bkgroundColor2, svgElement) {
  SVG_FillRect(x, y, width, height, bkgroundColor, bkgroundColor2, svgElement);
}
